<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <div class="vx-row">
      
        <div class="vx-col w-full mb-base">
          <vx-card>
            <div class="text-right">
              <vs-button color="warning" type="filled">Cancel</vs-button>
              <vs-button color="primary" type="filled" class="ml-5">Next</vs-button>
            </div>
            <h6 class="mt-10">The Telephone Number field supports 0-9, Aa-Zz, * or ? when the wildcard option is checked (Example: "*Hello*" or "312?Hi*7").</h6>
            <vs-table
              :sst="true"
              @search="handleSearch"
              @change-page="handleChangePage"
              @sort="handleSort"
              v-model="selected"
              pagination
              max-items="10"
              stripe
              :data="search_results">

                <template slot="header">
                    <h3></h3>

                    <div class="table-actions">
                      
                    </div>
                </template>

                <template slot="thead">
                  <vs-th sort-key="email">STATE</vs-th>
                  <vs-th sort-key="email">LATA</vs-th>
                  <vs-th sort-key="email">RATE CENTER</vs-th>
                  <vs-th sort-key="email">TIER</vs-th>
                  <vs-th sort-key="email">TELEPHONE NUMBER</vs-th>
                  <vs-th sort-key="email">QTY<i>*</i></vs-th>
                  <vs-th sort-key="email">WILECARD</vs-th>
                  <vs-th sort-key="email">SEQUENTIAL</vs-th>
                  <vs-th sort-key="email">ON-NET ONLY</vs-th>
                  <vs-th sort-key="email">LOCAL</vs-th>
                  <vs-th sort-key="email">ACTIONS</vs-th>
                  <vs-th sort-key="email">RESULTS</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td> <select><option>AR</option><option>VA</option></select> </vs-td>
                    <vs-td> <select><option>###</option><option>###</option></select> </vs-td>
                    <vs-td> {{ data[indextr].state }} </vs-td>
                    <vs-td> <select><option>###</option><option>###</option></select> </vs-td>
                    <vs-td> <vs-input class="inputx" /> </vs-td>
                    <vs-td> <vs-input class="input-qty" /> </vs-td>
                    <vs-td> <vs-checkbox /> </vs-td>
                    <vs-td> <vs-checkbox /> </vs-td>
                    <vs-td> <vs-checkbox /> </vs-td>
                    <vs-td> <vs-checkbox /> </vs-td>
                    <vs-td>
                      <a href="#"><feather-icon icon="PlusCircleIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" /></a>
                      <a href="#"><feather-icon icon="SearchIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  class="ml-2" /></a>
                    </vs-td>
                    <vs-td> 1/2 </vs-td>
                  </vs-tr>
                </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
      
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vx-card>
            <h4>SEARCH RESULTS</h4>
            <h6 class="mt-10">INSTRUCTIONS</h6>
            <span class="mt-2">Use the checkboxes to add Telephone Numbers from this table to the Order Queue table.</span>
            <div class="mt-10">
              <div style="font-weight:bold;">Wireline Tier Information</div>
              <div class="ml-5">
                <div>0 - US48 On-Net</div>
                <div>1 - US48 On-Net Premium</div>
                <div>2 - US48 Off-Net</div>
                <div>AK - Alaska</div>
                <div>CAN - Canada</div>
                <div>HI - Hawaii</div>
                <div>PRI - Puerto Rico</div>
              </div>
            </div>

            <div class="mt-10">
              <vs-table
                :sst="true"
                @search="handleSearch"
                @change-page="handleChangePage"
                @sort="handleSort"
                v-model="selected"
                pagination
                max-items="10"
                stripe
                :data="search_results">

                  <template slot="header">
                      <h3></h3>

                      <div class="table-actions">
                        <vs-button color="primary" type="filled">Download</vs-button>
                        <vs-button color="primary" type="filled" class="ml-5">Add Selected</vs-button>
                        <vs-button color="primary" type="filled" class="ml-5">Add All</vs-button>
                      </div>
                  </template>

                  <template slot="thead">
                    <vs-th width="16%" sort-key="email">LATA</vs-th>
                    <vs-th width="12%" sort-key="email">RATE CENTER</vs-th>
                    <vs-th width="12%" sort-key="email">STATE</vs-th>
                    <vs-th width="12%" sort-key="email">TELEPHONE NUMBER</vs-th>
                    <vs-th width="12%" sort-key="email">TIER</vs-th>
                    <vs-th width="12%" sort-key="email">ADD TO QUEUE</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td> {{ data[indextr].lata }} </vs-td>
                      <vs-td> {{ data[indextr].rate_center }} </vs-td>
                      <vs-td> {{ data[indextr].state }} </vs-td>
                      <vs-td> {{ data[indextr].telephone_number }} </vs-td>
                      <vs-td> {{ data[indextr].tier }} </vs-td>
                      <vs-td> <vs-checkbox /> </vs-td>
                    </vs-tr>
                  </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
        
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vx-card>
            <h4>ORDER QUEUE</h4>
            <div class="text-right">RESERVED TNS: <span>2</span> </div>
            <h6 class="mt-10">INSTRUCTIONS</h6>
            <span class="mt-2">
            Use 'X' icons to remove Telephone Numbers from this table, if you don't want to Order them.<br/>
            To Order the Numbers in this table: Click the "Next" button in upper right of this page.
            </span>
            
            <div class="mt-10">
              <vs-table
                :sst="true"
                @search="handleSearch"
                @change-page="handleChangePage"
                @sort="handleSort"
                v-model="selected"
                pagination
                max-items="10"
                stripe
                :data="search_results">

                  <template slot="header">
                      <h3></h3>

                      <div class="table-actions">
                        <vs-button color="primary" type="filled">Remove All</vs-button>
                      </div>
                  </template>

                  <template slot="thead">
                    <vs-th width="16%" sort-key="email">LATA</vs-th>
                    <vs-th width="12%" sort-key="email">RATE CENTER</vs-th>
                    <vs-th width="12%" sort-key="email">STATE</vs-th>
                    <vs-th width="12%" sort-key="email">TELEPHONE NUMBER</vs-th>
                    <vs-th width="12%" sort-key="email">Actions</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td> {{ data[indextr].lata }} </vs-td>
                      <vs-td> {{ data[indextr].rate_center }} </vs-td>
                      <vs-td> {{ data[indextr].state }} </vs-td>
                      <vs-td> {{ data[indextr].telephone_number }} </vs-td>
                      <vs-td> <a href="#"><feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" /></a> </vs-td>
                    </vs-tr>
                  </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
        
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      search_results: [
        {
          lata: 526,
          rate_center: 'MANSFIELD',
          state: 'AR',
          telephone_number: '4792691192',
          tier: 1
        },
        {
          lata: 526,
          rate_center: 'MANSFIELD',
          state: 'AR',
          telephone_number: '4792691192',
          tier: 1
        },
        {
          lata: 526,
          rate_center: 'MANSFIELD',
          state: 'AR',
          telephone_number: '4792691192',
          tier: 1
        },
        {
          lata: 526,
          rate_center: 'MANSFIELD',
          state: 'AR',
          telephone_number: '4792691192',
          tier: 1
        },
        {
          lata: 526,
          rate_center: 'MANSFIELD',
          state: 'AR',
          telephone_number: '4792691192',
          tier: 1
        },
        {
          lata: 526,
          rate_center: 'MANSFIELD',
          state: 'AR',
          telephone_number: '4792691192',
          tier: 1
        }
      ],
      caller_ids: [
        {id: 1, label: 'System-Provided'},
        {id: 3, label: 'Caller ID 1'},
        {id: 2, label: 'Caller ID 2'}
      ],
      selected: {id: 1, label: 'System-Provided'},      
      textarea: '',
      counterDanger: false,
      radios1:'luis'
    }
  },
  mounted () {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
.a-icon {
    font-size: 26px;
}
.chat-card-log {
    height: 400px;

    .chat-sent-msg {
        background-color: #f2f4f7 !important;    
    }


}

.echarts {
  margin-top: -80px;
}

.schedule-item {
  display: flex;
  align-items: center;
  width: 100%;

  .flex {
    align-items: center;
  }
  
}

.table-actions {
  padding: 10px 0px;
}

table {
  tr {
    td {
      select {
        padding: 5px 10px;
        border-radius: 5px;
        border: solid 1px lightgrey;
        color: #2c2c2c;
      }

      .input-qty {
        width: 60px;
      }
    }
  }
}
</style>
